export enum UserStatus {
    Pending = "userStatus.pending",
    Notified = "userStatus.notified",
    PendingDelete = "userStatus.pendingDelete",
    Registered = "userStatus.registered",
    Blocked = "userStatus.blocked",
    ToBeConfirmed = "userStatus.toBeConfirmed",
    Revoked = "userStatus.revoked"
}